import { WizardSimpleStepProps } from "./types";

export default function WizardSimpleStep(_: Readonly<WizardSimpleStepProps>) {
  return null;
}
